'use strict';

var box = {};

exports.__exports = box;
//# sourceMappingURL=box2.cjs.map
